import { render, staticRenderFns } from "./MapPricing.vue?vue&type=template&id=cb879adc&scoped=true&"
import script from "./MapPricing.vue?vue&type=script&lang=js&"
export * from "./MapPricing.vue?vue&type=script&lang=js&"
import style0 from "./MapPricing.vue?vue&type=style&index=0&id=cb879adc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb879adc",
  null
  
)

export default component.exports